function finiteNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function localHour(now) {
  const date = now instanceof Date ? now : new Date(now);
  return Number.isNaN(date.getTime()) ? new Date().getHours() : date.getHours();
}

export function sensorWeatherStatus(sensor, now = new Date()) {
  const reading = sensor?.latestReading || {};
  const rain = finiteNumber(reading.rain_mm);
  const humidity = finiteNumber(reading.rh_perc);
  const temperature = finiteNumber(reading.temp_c);

  if (rain === null && humidity === null && temperature === null) {
    return { key: 'unknown', icon: '🌦️', label: 'Condição do tempo indisponível' };
  }

  if (rain !== null && rain > 0) {
    return { key: 'rain', icon: '🌧️', label: 'Chuva detectada no local' };
  }

  const hour = localHour(now);
  const daytime = hour >= 6 && hour < 18;

  if (!daytime) {
    return humidity !== null && humidity >= 90
      ? { key: 'cloudy-night', icon: '☁️', label: 'Noite úmida, sem chuva detectada' }
      : { key: 'clear-night', icon: '🌙', label: 'Noite sem chuva detectada' };
  }

  if (humidity !== null && humidity >= 90) {
    return { key: 'cloudy', icon: '☁️', label: 'Tempo úmido, sem chuva detectada' };
  }

  if (humidity !== null && humidity >= 75) {
    return { key: 'partly-cloudy', icon: '🌥️', label: 'Tempo parcialmente nublado' };
  }

  return { key: 'sunny', icon: '🌤️', label: 'Tempo seco com sol' };
}
